import React from 'react';

const RemoveSigaa: React.FC = () => {
  return (
    <>
      <h3>Vish, não vai dar... Como retiro uma disciplina?</h3>
      <p>
        A retirada de disciplina é pedida diretamente ao SAA. Ela pode ser feita
        online, ou por meio de e-mail para{' '}
        <span className="negrito">saaatendimento@unb.br</span>. Isto é feito
        para agilizar o processo de retirada, uma vez que a não é necessária a
        intervenção ou autorização da coordenação.
      </p>
    </>
  );
};

export default RemoveSigaa;
